import injectIfiAd from "./inject-ifi-ad";

const { MedscapeTV, webmd, IntersectionObserver } = window;


class AdsHandler {
    constructor(store,adsConfig,seriesConfig) {
        this.store = store;
        this.adsConfig = adsConfig;
        this.seriesConfig = seriesConfig;
        //this.locationState = Object.assign({}, DefaultLocationState);
        this.loadedAds = {};
        this.intersectingAds = {};
        //console.log("[AdsHandler] constructor:",arguments);
    }

    get adEls() {
        return [...document.querySelectorAll("[data-ad]")];

    }

    get adsData() {
        let { adEls } = this;
        let adsData = adEls.map(adEl => {
            return JSON.parse(adEl.dataset.ad);
        }).filter(adData => {
            const { id } = adData;
            if (id == "ads-pos-122") {
                return false;
            } else if (window.breakpoint < 3 && id == "ads-pos-712") {
                return false;
            } else {
                return true;
            }
        })
        return adsData;
    }

    get lazyloadAdEls() {
        let { adEls } = this;
        adEls = adEls.filter(adEl => {
            const adData = JSON.parse(adEl.dataset.ad);
            const { id } = adData;
            if (id == "ads-pos-122") {
                return false;
            } else if (window.breakpoint < 3 && id == "ads-pos-712") {
                return false;
            } else {
                return true;
            }
        })
        return adEls;
    }
    handleRouteChange(pathname) {
        const { adsConfig } = this;

        this.updateSponsors(pathname);

        if (adsConfig.refresh === true && adsConfig.isLazyLoad === true) {
            this.loadedAds = {}
            this.adEls.forEach(adEl => {
                adEl.innerHTML = '';
            });
            let rightAd = document.getElementById('ads-pos-122');
            if (rightAd != null) {
                const adData = JSON.parse(rightAd.dataset.ad);
                this.load(adData);
            }
            let intersectingAds = Object.values(this.intersectingAds);
            intersectingAds.forEach(adData => {
                this.load(adData);
            })
        } else if (MedscapeTV.ads.refresh === true) {
            this.refresh();
        }
    }
    updateSponsors(pathname = document.location.pathname) {
        const { seriesConfig: series, adsConfig } = this;
        const { sponsors } = adsConfig;
        if (sponsors != null && sponsors.enable === true) {
            const sponsor = sponsors.values.find(sponsor => {
                return pathname === `${series.path}${sponsor.path}`;
            })
            const value = sponsor != null ? sponsor.value : sponsors.default;
            const pageTargetValue = value.trim() == "" ? "" : value.split(",");
            //console.log("[AdsHandler] updateSponsors:",pageTargetValue);
            webmd.ads2.setPageTarget('spon', pageTargetValue);
        }
    }
    init(location = document.location) {
        const { adsConfig } = this;
        const { pathname } = location;
        this.updateSponsors(pathname);
        if (adsConfig.isLazyLoad) {
            this.initLazyLoad();

        } else {
            this.adsData.forEach(adData => {
                this.load(adData);
            })
        }

        injectIfiAd();
    }
    initLazyLoad() {
        let { lazyloadAdEls } = this;

        const observerOptions = {
            root: null,
            rootMargin: '0px',
            threshold: [0, .25]
        }
        const callback = (entries, observer) => {
            let { loadedAds } = this;
            entries.forEach((entry) => {
                let target = entry.target;
                let adData = JSON.parse(target.dataset.ad);
                if (entry.isIntersecting) {
                    this.intersectingAds[adData.id] = adData;
                    if (loadedAds[adData.id] == null) {
                        this.load(adData);
                    }
                } else if (adData != null) {
                    delete this.intersectingAds[adData.id];
                }
            });
        }
        lazyloadAdEls.forEach(adEl => {
            const container = adEl;

            this.videoContainer = container;
            this.observer = new IntersectionObserver(callback, observerOptions);
            this.observer.observe(container);
        })


    }
    load(adData = null) {
        if (adData != null) {
            // Check to see if ad is already defined
            this.loadedAds[adData.id] = true;
            if (!webmd.ads2.ads[adData.id]) {
                webmd.ads2.defineAd(adData);
                webmd.ads2.display();
            } else {
                webmd.ads2.refresh(adData);
            }
        }
    }
    refresh() {
        if (webmd != null && webmd.ads2 != null) {
            try {
                webmd.ads2.refresh();
            } catch (e) {
                console.error(e);
            }
        }
    }
}


export default AdsHandler;